// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2c-qF","label":"Category_label__1CMEC","content":"Category_content__10o3V","header":"Category_header__1uDUz","location":"Category_location__UNk8N"};